import {GetPriceRes} from 'epic-graphql-types';

export const extractPriceDetails = (price: GetPriceRes) => {
	if (!price) {
		return {};
	}

	const totalPrice = price.totalPrice || {};
	const currencyCode = totalPrice.currencyCode;
	const fmtPrice = totalPrice.fmtPrice || {};
	const originalPriceStr = fmtPrice.originalPrice;
	const discountPriceStr = fmtPrice.discountPrice;
	const hasPrice = Boolean(originalPriceStr && originalPriceStr.length);

	const isSale = Boolean(
		hasPrice && discountPriceStr?.length && originalPriceStr !== discountPriceStr
	);

	const isFree: boolean = !hasPrice || totalPrice.originalPrice === 0;

	return {
		priceDisplay: isFree ? null : isSale ? discountPriceStr : originalPriceStr,
		isSale,
		isFree,
		hasPrice,
		currencyCode,
		currencyInfo: totalPrice?.currencyInfo || {}
	};
};
